import React from "react";
import {
    DefaultButton,
    FocusTrapCallout,
    DirectionalHint,
    Icon,
    Panel
} from "office-ui-fabric-react";
import { EventEmitter } from "./events";
import { FontIcon } from "office-ui-fabric-react/lib/Icon";

import CaselyLogo from "../images/caselyLogo.png";

class WaffleMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isCalloutVisible: false,
            apiURL: JSON.parse(localStorage.getItem("api"))
        }
    }

    onWaffleOpen = () => {
        this.setState({
            isCalloutVisible: true
        })
    }

    onWaffleClose = () => {
        this.setState({
            isCalloutVisible:false
        })
    }

    onOpenLink = (url) => {
        window.open(url);
    }

    render() {
        return (
            <div className='waffle-holder'>
                <Icon
                    className='waffle-icon'
                    iconName="Waffle"
                    onClick={this.onWaffleOpen}
                />
                {this.state.isCalloutVisible ? (
                    <Panel
                        className='waffle-panel'
                        headerText=""
                        isOpen={true}
                        onDismiss={this.onWaffleClose}
                        // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
                        closeButtonAriaLabel="Close"
                    >
                        <div className='section-holder'>
                            <h3>Apps</h3>
                            <div className='apps-holder'>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='item-holder' onClick={() => { this.onOpenLink(this.state.apiURL.navigatorUrl) }}>
                                            <img src={CaselyLogo} />
                                            Casely
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='item-holder' onClick={() => { this.onOpenLink(this.state.apiURL.CaselyInsightsURL) }}>
                                            <img src={CaselyLogo} />
                                            Casely Insights
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='item-holder' onClick={() => { this.onOpenLink(this.state.apiURL.TMAgentURL) }}>
                                            <img src={CaselyLogo} />
                                            TM Agent Portal
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Panel>
                ) : null}
            </div>
            )
    }
}

export default WaffleMenu;